import * as styles from './openPickFileDialog.module.scss';

function openPickFileDialog(options: {
  onFilesPicked: (files: FileList | null) => void;
  extensions: string;
}) {
  const fileUploadInput = document.createElement('input');
  fileUploadInput.onchange = () => {
    options.onFilesPicked(fileUploadInput.files);
    fileUploadInput.remove();
  };
  fileUploadInput.oncancel = () => {
    options.onFilesPicked(null);
    fileUploadInput.remove();
  };

  fileUploadInput.type = 'file';
  fileUploadInput.className = styles.fileInput;
  fileUploadInput.accept = options.extensions;
  document.body.appendChild(fileUploadInput);
  fileUploadInput.click();
}

export default openPickFileDialog;
